import React from 'react';
import PropTypes from 'prop-types';
import isString from 'lodash/isString';
import { Icon } from 'xm-spark';

import styles from './QuickStartActionCardIcon.module.scss';

export default function QuickStartActionCardIcon({ sectionIcon }) {
  return isString(sectionIcon) ? (
    <Icon type={sectionIcon} className={styles.icon} />
  ) : (
    <Icon type="svg" className={styles.icon}>
      {sectionIcon}
    </Icon>
  );
}

QuickStartActionCardIcon.propTypes = {
  sectionIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
};

QuickStartActionCardIcon.displayName = 'QuickStartActionCardIcon';
